/**
 * Industry Sectors Section
 *
 * Desktop: CSS :hover handles the flex-grow accordion. The custom element
 *          below is registered so the browser recognises the tag and
 *          no "unknown element" warnings appear; no JS logic needed there.
 *
 * Mobile:  Info-button toggles `.is-flipped` on the card, which fades
 *          the image out and the text panel in. Close-button removes it.
 *          Both buttons update aria-expanded accordingly.
 */
(function () {
  'use strict';

  /* ── Desktop: custom element stub (CSS does all the work) ─────────────── */
  if (!customElements.get('industry-sectors-component')) {
    customElements.define(
      'industry-sectors-component',
      class IndustrySectorsComponent extends HTMLElement {}
    );
  }

  /* ── Mobile: flip cards ───────────────────────────────────────────────── */
  function initMobileFlip(scope) {
    scope.querySelectorAll('.industry-sectors__mobile-card').forEach((card) => {
      const infoBtn  = card.querySelector('.industry-sectors__info-btn');
      const closeBtn = card.querySelector('.industry-sectors__close-btn');

      if (!infoBtn || !closeBtn) return;

      infoBtn.addEventListener('click', () => {
        card.classList.add('is-flipped');
        infoBtn.setAttribute('aria-expanded', 'true');
      });

      closeBtn.addEventListener('click', () => {
        card.classList.remove('is-flipped');
        infoBtn.setAttribute('aria-expanded', 'false');
      });
    });
  }

  function init() {
    document.querySelectorAll('.industry-sectors').forEach(initMobileFlip);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  /* re-init when Shopify theme editor reloads a section */
  if (window.Shopify && Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.industry-sectors');
      if (section) initMobileFlip(section);
    });
  }
})();
